import style from "../css/images.module.css";
import { useState, useRef, useEffect } from "react";
import Api from '../helperFunctions/Api2';
import { useDispatch, useSelector } from "react-redux";
import { addImage, setImages, removeImage } from "../redux/reducers/questionReducer";
import { Link } from "react-router-dom";

const UploadImage = ({ modalTogglee, closeModal, setShowLoading, onCopy }) => {
    const [shouldImageDivShow, setShouldImageDivShow] = useState(false);
    const images = useSelector((state) => state.questions.images);
    // const [imageSource, setImageSource] = useState('');
    const uploadedImage = useRef();
    const imageInput = useRef();
    const dispatch = useDispatch();
    const [imgIndex, setImgIndex] = useState(-1);
    // const [loadingState, setLoadingState] = useState("loading");
    const [shouldShow, setShouldShow] = useState(true);

    const fetchProducts = async () => {
        Api.getApi('/question/get-question-images', true)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                //alert("Just entered")       
                if (shouldShow) {
                    dispatch(setImages(result.data));
                    // setLoadingState("ready");
                }
            })
            .catch(err => {
                // if (shouldShow) setLoadingState("error");
            });
    };

    useEffect(() => {
        setShouldShow(true);
        if (images.length === 0) {
            fetchProducts();
        }
        else {
            // if (shouldShow) setLoadingState("ready");
        }
        return () => {
            setShouldShow(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={style.modal} style={{ display: modalTogglee ? "block" : "none" }}>
            <div className={style.modal_content}>
                <div className={style.modal_header}>
                    <span className={style.close} onClick={closeModal}>&times;</span>
                    <span className={style.upload_wrapper}>
                        <button>Upload New Image</button>
                        <input ref={imageInput} type="file" accept="image/*" onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                const reader = new FileReader();
                                reader.onload = function (a) {
                                    //alert(a.target.result)
                                    uploadedImage.current.src = a.target.result;
                                    setShouldImageDivShow(true);
                                    //console.log(shouldImageDivShow, "information")
                                };
                                reader.readAsDataURL(e.target.files[0]);
                            }
                        }} />
                    </span>
                </div>
                <div className={style.modal_body}>
                    <div style={{ display: shouldImageDivShow ? 'block' : 'none' }}>
                        <img width="200" ref={uploadedImage} alt="" /><br />
                        <Link className={style.styledlink} onClick={() => {
                            setShowLoading(true);
                            let imageToBeUploaded = new FormData();
                            imageToBeUploaded.append('file', imageInput.current.files[0]);
                            imageToBeUploaded.append('file_type', 'image');

                            Api.PostFormData('/question/save-question-image', imageToBeUploaded, true)
                                .then(result => {
                                    setShowLoading(false);
                                    //console.log(result, "Before ");
                                    //result = JSON.parse(result.body);
                                    //console.log(result, "After")
                                    if (result.isSuccessful) {
                                        //console.log(result, 'from uploadedimage');
                                        dispatch(addImage(result.data));
                                        //uploadedImage.current.src="";
                                        setShouldImageDivShow(false);
                                        alert('image saved successfully');
                                    }
                                    else {
                                        alert("Action failed");
                                        //navigate("/account/sign-in")
                                    }
                                });
                        }}>Save selected image </Link>
                    </div>
                    <div>
                        {
                            images.length > 0 ? (
                                <div style={{ textAlign: 'left' }}>
                                    {images.map((image, index) => (
                                    <div key={index} className={style.imgDiv} onClick={() => setImgIndex(index)} style={{ border: imgIndex == index ? '2px solid var(--primary-color)' : '0px solid var(--primary-color)' }}>
                                        <div >
                                            <img src={`${Api.img_domain}/upload/questions/${image.source}`} height="85" />
                                        </div>
                                    </div>
                                ))
                                }</div>
                            ) :
                                (
                                    <>No image have been uploaded by you</>
                                )
                        }
                    </div>
                </div>
                <div className={style.modal_footer}>
                    <div className={style.btnDiv}>
                        <button onClick={(e)=>{
                            e.preventDefault();
                            if(imgIndex < 0){
                                alert("Please select an image");
                            }
                            else{
                                if(window.confirm('Are you sure you want to delete this image?')){
                                    setShowLoading(true);
                                    Api.PostApi('/question/delete-user-image', {
                                        id: images[imgIndex].id
                                    }, true)
                                    .then(result=>{
                                        console.log(result, "just res")
                                        alert(result.message)
                                        if(result.isSuccessful){
                                            dispatch(removeImage({id: images[imgIndex].id}));
                                        }
                                    })
                                    .finally(()=>{
                                        setShowLoading(false);
                                    })
                                }
                            }
                        }}>Delete Image</button>&nbsp;
                        <button onClick={(e) => {
                            e.preventDefault();
                            if (imgIndex < 0) {
                                alert("Please select an image");
                            }
                            else {
                                var textField = document.createElement('textarea');
                                textField.innerText = `${Api.domain}/upload/questions/${images[imgIndex].source}`;
                                document.body.appendChild(textField);
                                textField.select();
                                document.execCommand('copy');
                                textField.remove();
                                onCopy && onCopy(textField.innerHTML)
                                //navigator.clipboard.writeText('Welcome men');
                                alert('Image link copied successfully');
                                closeModal()
                            }

                        }}>Copy Image Link</button>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default UploadImage;